import { Outlet } from "react-router-dom";
import AutherProvider from "../Context/AutherProvider/AutherProvider";
import SiteSettingProvider from "../Context/SiteSettingsProvider/SiteSettingsProvider";
import NoInternet from "../Components/StyledComponent/NoInternet";

export const AutherRoutes = () => {
  return (
    <AutherProvider>
        <SiteSettingProvider>
        <NoInternet /> 
        <Outlet />
        </SiteSettingProvider> 
    </AutherProvider>
  );
}
